module.exports = __webpack_public_path__ + "img/132_thumbnail.5845deb7.jpg";